import React from 'react';
import { Bell, Logs } from 'lucide-react';

import './Navbar.css';
import { useAppSelector } from '../app/hooks';
import { GatewayLogType, NotificationType } from '../utils/types';
import { numUnreadNotifications } from '../utils/functions';
import LanguageMenu from '../components/ui/language-selector/language-menu';
import UserControl from '../components/user-control/user-control';

interface NavbarProps {
  darkMode: boolean;
  loggedIn?: boolean;
  loggedInRefreshTrigger?: number;
  username?: string;
  gatewayLogs: GatewayLogType[];
  onClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Navbar = ({
  loggedIn,
  loggedInRefreshTrigger,
  username,
  gatewayLogs,
  onClickHandler,
}: NavbarProps) => {
  const sNotifications: NotificationType[] = useAppSelector(
    (state) => state.app.notifications,
  );
  const unreadCount: number = numUnreadNotifications({ notifications: sNotifications });

  return (
    <header className="gateway-navbar">
      <div className="navbar-right">
        <button
          name="viewNotifications"
          className="navbar-icon-btn"
          onClick={onClickHandler}
          title="Notifications"
        >
          <Bell size={20} />

          {unreadCount > 0 && <span className="navbar-badge">{unreadCount}</span>}
        </button>

        <button
          name="btnLogs"
          className="navbar-icon-btn"
          onClick={onClickHandler}
          title="Logs"
        >
          <Logs size={20} />

          {gatewayLogs?.length > 0 && (
            <span className="navbar-badge">{gatewayLogs.length}</span>
          )}
        </button>

        <div className="navbar-language">
          <LanguageMenu />
        </div>

        <div className="navbar-user-wrapper">
          <UserControl
            key={username + (loggedIn ? 'T' : 'F') + loggedInRefreshTrigger}
            buttonHandler={onClickHandler}
          />
        </div>
      </div>
    </header>
  );
};

export default Navbar;
